<template lang="es">
     <div :style="myStyle" class="completo">
      <div  v-if="!editing" class="custom_cursor">
        <p @click="edit" :style="valueStyle" id="value1-value-label">
          {{value}}
       </p>
      </div>
      <TecladoNumerico  
        :titulo="titulo"
        :valor_original="value"
        :valor_max="valor_max"
        :valor_min="valor_min"
      @aceptar="aceptar" 
      @cancelar="editing=false" 
      v-if="editing"/>
      <!-- <v-row v-if="editing">
        <v-col cols="4"> 
          <div class="elementos-izquierda">
            <v-text-field class="text-green" v-model="current_data"></v-text-field>
          </div>
        </v-col>
        <v-col cols="4">
          <v-btn class="full_heigth" block @click="escribir">OK</v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn class="full_heigth" block @click="cancelar">Cancel</v-btn>
        </v-col>
      </v-row> -->

      <!-- <v-btn v-if="!editing" @click="edit"><v-icon >mdi-pencil</v-icon> </v-btn> -->
    </div>
</template>
<script>
import TecladoNumerico from './TecladoNumerico.vue'
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  name: "KoioteValueLabelWriteOne",
  components:{
    TecladoNumerico
  },
  props: {
    myProps: Object,
    h:Number,
    w:Number
  },
  created(){
    console.log("Creando koiote value label write one")
    // console.log(this.myProps)
    // console.log("el value es")
    // console.log(this.value)
  },
  data() {
    return {
      editing:false,
      current_data:null
    }
  },
  mounted() {
    this.current_data=this.value

  },

  methods: {
    cancelar(){
      this.editing=false
    },
    aceptar(v){
      console.log("ha aceptado con valor",v)
      this.current_data=parseFloat(v)
      this.escribir()
      this.editing=false
    },
    escribir(){
      const escala=this.myProps.customizables.scale
      const numero_a_escribir = this.current_data/escala;
      console.log("El numero a escribir es")
      console.log(numero_a_escribir)
      this.editing=false
      if(this.myPlc && Object.keys(this.myPlc).length > 0 ){
          let functionName = this.myPlc.type.replace(' ','') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
          functionName = 'writeIntIn'+functionName
          const componente_escritura={
            'variable':this.myProps.customizables.variable,
            plc:this.myProps.customizables.plc
          }
          console.log("^")
          console.log(functionName)
          console.log(componente_escritura)
          console.log(numero_a_escribir)
          console.log("--")
          return this[functionName](componente_escritura,numero_a_escribir)
        }
    },
    edit(){
      this.current_data=this.value
      this.editing=true;
    }
  },

  computed: {
    ...mapState('nodered',['message','ListOfmessages']),
    ...mapGetters('nodered',['getConnections']),
    bufferPos(){
      if(this.myPlc){
        let plcType =  this.myPlc.type.replace(' ','') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
        let functionName = 'calculate'+plcType+'BufferPos'
        return this[functionName](this.myProps.customizables, this.myPlc)
      }else return 'infinitisimo'
    },
    dataType(){
      if(this.myPlc){
        let plcType =  this.myPlc.type.replace(' ','') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
        let functionName = 'calculate'+plcType+'VarType'
        return this[functionName](this.myProps.customizables, this.myPlc)
      }
    },
    myPlc(){
      if(this.myProps.customizables.topic != ""){
        return this.getConnections.find(e => e.id == this.myProps.customizables.plc)
      }
    },
    ancho(){
        let minimo = Math.min(this.h, this.w)
        if(document.documentElement.clientWidth >= 700)
            return minimo/2
        else
            return minimo/4
    },
    myStyle() {
      return {
        backgroundColor: this.myProps.customizables.background_color,
        color: this.myProps.customizables.foreground_color,
        border: "1px solid " + this.myProps.customizables.border_color,
        fontSize: this.ancho+'px'
      };
    },
    valueStyle() {
      return { // automatico desde el css para que no haya que modificar todos manualmente
        // fontSize: this.myProps.customizables.font_size + "rem",
      };
    },
    value(){
      let miMensaje = this.ListOfmessages.find(a=>a.topic==this.myProps.customizables.topic)
      if(miMensaje){
        if(this.myPlc && Object.keys(this.myPlc).length > 0 ){
          let functionName = this.myPlc.type.replace(' ','') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
          functionName = 'readValueFrom'+functionName
          return this[functionName](miMensaje,this.myProps.customizables, this.bufferPos, this.dataType, this.myPlc)
        }
      }else{
        // console.log('No hay mensaje de ese topic :(');
      }
    },

    valor_max(){
      return this.myProps.customizables.max
    }, valor_min(){
      return this.myProps.customizables.min
    },
    titulo(){
      return this.myProps.customizables.titulo
    }

  },
  watch:{

    value(){
      if(this.value != undefined){
        this.$emit('cambioValor', {id: this.myProps.id_draggable, value: this.value})
      }
    },
   }
};
</script>
<style>
#value1-value-label {
  margin: 0;
  padding: 0;
}
.text-green input {
      color: green !important;
    }
    .elementos-en-una-linea {
  white-space: nowrap; /* Evita saltos de línea */
}
.full_heigth{
  height: 100% !important;
}
.custom_cursor {
      cursor: pointer; /* Change the cursor to a pointer hand */
    }
/* @media screen and (max-width: 600px) {
  .completo {
    position:relative;
    width:100%;
  }
} */

/* @media screen and (min-width: 1200px) {
  .completo {
    font-size: 6em; 
  }
} */

</style>